export default "__VITE_ASSET__9c954a62__"